import { Fragment } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoCitas from "../citas/InfoCitas";
function Citas() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Reserva una cita en el taller Hyundai de tu preferencia de forma rápida y fácil. Revisa servicios disponibles por cada taller"
        />
        <meta
          name="keywords"
          content="Citas Hyundai, Citas, Citas digitales, Taller, Talleres Hyundai"
        />
        <title>Citas Talleres Hyundai</title>
      </Helmet>
      <Menu />
      <InfoCitas />
    </Fragment>
  );
}
export default Citas;